// ============================================================
// cf-files.js — CF.files (tampilan foto ber-otentikasi)
// ============================================================
// Endpoint file dilindungi JWT sehingga <img src> polos tidak bisa —
// thumbnail di-fetch dengan bearer lalu dipasang sebagai object URL.
//
// Public API:
//   CF.files.thumbInto(imgEl, fileId)   — isi <img> dgn thumbnail
//   CF.files.open(fileId)               — buka file penuh di tab baru
//   CF.files.strip(el, files)           — render deretan thumbnail
//        files: [{id, originalFileName?}] (bentuk photos[] customer /
//        FileAttachmentResponse); klik → open()
// ============================================================

window.CF = window.CF || {};

CF.files = (function () {
    'use strict';

    function _apiBase() {
        return (typeof API_BASE_URL !== 'undefined' && API_BASE_URL) ? API_BASE_URL : '';
    }

    function _fetchBlob(path) {
        var token = CF.auth.getAccessToken();
        return fetch(_apiBase() + path, {
            headers: token ? { 'Authorization': 'Bearer ' + token } : {}
        }).then(function (r) { return r.ok ? r.blob() : null; });
    }

    function thumbInto(imgEl, fileId) {
        _fetchBlob('/api/v1/files/' + fileId + '/thumbnail')
            .then(function (blob) {
                if (blob) imgEl.src = URL.createObjectURL(blob);
                else imgEl.alt = 'foto tidak tersedia';
            })
            .catch(function () { imgEl.alt = 'foto gagal dimuat'; });
    }

    function open(fileId) {
        _fetchBlob('/api/v1/files/' + fileId + '/download')
            .then(function (blob) {
                if (!blob) { CF.toast.error('Foto tidak tersedia.'); return; }
                window.open(URL.createObjectURL(blob), '_blank');
            })
            .catch(function () { CF.toast.error('Gagal memuat foto.'); });
    }

    function strip(el, files) {
        if (!el) return;
        files = files || [];
        if (!files.length) {
            el.innerHTML = '<span style="font-size:12.5px;color:#94A3B8">Tidak ada foto.</span>';
            return;
        }
        el.innerHTML = '';
        el.style.cssText += ';display:flex;flex-wrap:wrap;gap:8px';
        files.forEach(function (f) {
            var img = document.createElement('img');
            img.style.cssText =
                'width:76px;height:76px;object-fit:cover;border-radius:8px;' +
                'border:1px solid #E2E8F0;cursor:pointer;background:#F1F5F9';
            img.title = (f.originalFileName || 'foto') + ' — klik untuk memperbesar';
            img.addEventListener('click', function () { open(f.id); });
            el.appendChild(img);
            thumbInto(img, f.id);
        });
    }

    return { thumbInto: thumbInto, open: open, strip: strip };
})();
